/* eslint-disable no-underscore-dangle */
import React from 'react';

import styles from '../../styles/timebase-testseries.module.scss';

function TopHeader() {
  return (
    <div className={styles.topHeaderWrapper}>
      <div className={styles.heading}>
        <button type="button" className={styles.free}>
          Free
        </button>
        <h1 className={styles.heading_}>All Live Tests and Quizzes</h1>
      </div>
      <p className={styles.subheading1}>
        Explore our live tests & analyse where you stand against your competitors with our AIR feature. Improve your
        selection rates & get a better chance at clearing your exam.
      </p>
    </div>
  );
}

export default TopHeader;
